import axios from "axios";
import getSignature from "./getSignature";
import { BasicInfo, toastFailed } from "./../Config/BasicInfo";
import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
const baseURL = process.env.REACT_APP_API_URL;
// const baseURL = "http://82.29.160.120:8800/user";
// const baseURL = "http://82.29.160.120:8800/user";

const useAxiosHelper = () => {
  // const navigate = useNavigate();

  const dispatch = useDispatch();
  const AxiosGet = async (endPoint, body) => {
    const headers = await getSignature();
    console.log("baseURL----", baseURL);
    try {
      const response = await axios.get(`${baseURL}${endPoint}`, { headers });
      BasicInfo.isDebug && console.log(`${endPoint} = `, response);
      return response.data;
    } catch (error) {
      BasicInfo.isDebug && console.log(`${endPoint} = `, error);
      if (error?.response?.data?.code === 419) {
        toastFailed(error?.response?.data?.message);
        // navigate('/')
        // window.location.href = '/';
      }
    }
  };

  const AxiosPost = async (endPoint, body) => {
    BasicInfo.isDebug && console.log("endPoint", baseURL);
    const headers = await getSignature();
    console.log("baseURL----", baseURL);
    try {
      const response = await axios.post(`${baseURL}${endPoint}`, body, {
        headers,
      });
      BasicInfo.isDebug && console.log("response", response);
      BasicInfo.isDebug && console.log(`${endPoint} = `, response);
      return response.data;
    } catch (error) {
      BasicInfo.isDebug && console.log(`${endPoint} = `, error);
      if (error?.response?.data?.code === 419) {
        toastFailed(error?.response?.data?.message);
        // navigate('/')
        // window.location.href = '/';
      }
      throw error;
    }
  };

  return { AxiosGet, AxiosPost };
};

export default useAxiosHelper;
